import { createTV } from "tailwind-variants";

const customFontSizeClass = (classPart: string) => /(head|body|ui)\d+/.test(classPart);

export const tv = createTV({
  twMergeConfig: {
    classGroups: {
      // NOTE: text-colorとfont-sizeがmergeされるのを防ぐため。SEE: https://github.com/dcastil/tailwind-merge/blob/v1.14.0/docs/configuration.md
      "font-size": [{ text: [customFontSizeClass] }],
    },
  },
});
